import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  USER_CHECK_USER_EXISTS_BY_EMAIL_BEGIN,
  USER_CHECK_USER_EXISTS_BY_EMAIL_SUCCESS,
  USER_CHECK_USER_EXISTS_BY_EMAIL_FAILURE,
  USER_CHECK_USER_EXISTS_BY_EMAIL_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import config from '../../../common/config';
import { createAxiosConfigWithAuth } from '../../../common/apiHelpers';

export function checkUserExistsByEmail(args = {}) {
  return (dispatch, getState) => {
    // optionally you can have getState as the second argument
    dispatch({
      type: USER_CHECK_USER_EXISTS_BY_EMAIL_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${config.apiRootUrl}/check-user-exists-by-email/${args.email}`,
        createAxiosConfigWithAuth(getState()),
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: USER_CHECK_USER_EXISTS_BY_EMAIL_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: USER_CHECK_USER_EXISTS_BY_EMAIL_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissCheckUserExistsByEmailError() {
  return {
    type: USER_CHECK_USER_EXISTS_BY_EMAIL_DISMISS_ERROR,
  };
}

export function useCheckUserExistsByEmail() {
  const dispatch = useDispatch();

  const { checkUserExistsByEmailPending, checkUserExistsByEmailError } =
    useSelector(
      (state) => ({
        checkUserExistsByEmailPending: state.user.checkUserExistsByEmailPending,
        checkUserExistsByEmailError: state.user.checkUserExistsByEmailError,
      }),
      shallowEqual,
    );

  const boundAction = useCallback(
    (...args) => {
      return dispatch(checkUserExistsByEmail(...args));
    },
    [dispatch],
  );

  const boundDismissError = useCallback(() => {
    return dispatch(dismissCheckUserExistsByEmailError());
  }, [dispatch]);

  return {
    checkUserExistsByEmail: boundAction,
    checkUserExistsByEmailPending,
    checkUserExistsByEmailError,
    dismissCheckUserExistsByEmailError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case USER_CHECK_USER_EXISTS_BY_EMAIL_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        checkUserExistsByEmailPending: true,
        checkUserExistsByEmailError: null,
      };

    case USER_CHECK_USER_EXISTS_BY_EMAIL_SUCCESS:
      // The request is success
      return {
        ...state,
        checkUserExistsByEmailPending: false,
        checkUserExistsByEmailError: null,
      };

    case USER_CHECK_USER_EXISTS_BY_EMAIL_FAILURE:
      // The request is failed
      return {
        ...state,
        checkUserExistsByEmailPending: false,
        checkUserExistsByEmailError: action.data.error,
      };

    case USER_CHECK_USER_EXISTS_BY_EMAIL_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        checkUserExistsByEmailError: null,
      };

    default:
      return state;
  }
}
